export function confirmChangeImpact(impact) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent("change-impact:open", { detail: { impact, resolve } }))
  })
}
